import Indoor from './components/Indoor';

export default Indoor;
